export const getDisplayCount = (page = 1, size = 0, total = 0) => {
  const startingIndex =
    total > (page - 1) * size + 1 ? (page - 1) * size + 1 : total;
  const endIndex = total > size * page ? size * page : total;

  return (
    <p>
      Showing&nbsp;&nbsp;<span className="dark-text">{startingIndex}</span>
      &nbsp;-&nbsp;
      <span className="dark-text">{endIndex}</span>&nbsp;of&nbsp;
      <span className="dark-text"> {total}&nbsp; </span> items
    </p>
  );
};
